import React, { useContext, useEffect } from 'react'
import "./style.scss"
import ApplicationDetails from './applicationDetails/ApplicationDetails';
import PieChart from "./chart/PieChart";
import { TasksContext } from '../../../../../../../../providers/tasks-provider';
import { FlowDetailsContext } from '../../../../../../../../providers/flowDetails-provider';
import { FilterContext } from '../../../../../../../../providers/filterData-provider';
import { useFetch } from '../../../../../../../../hooks';

const ChartComponent = () => {

    const { taskDetails, setTaskDetails } = useContext(TasksContext);
    const { cardData, flowDetails } = useContext(FlowDetailsContext);
    const { selectedLendFilterValues } = useContext(FilterContext);
    const { api } = useFetch();

    // const filterData = Object.keys(selectedLendFilterValues)?.map(key => {
    //     const filterConfig = lendFilterList?.find(ele => ele?.FILTER_ID === key);

    //     if (key === 'from' || key === 'to') {
    //         const dateFilterData = lendFilterList?.find(ele => ele?.DISPLAY_TYPE === 'DATE_PICKER');
    //         if (dateFilterData) {
    //             return {
    //                 id: `${dateFilterData.BASE_TABLE}.${dateFilterData.BASE_COLUMN}`,
    //                 datatype: 'DATE',
    //                 value: {
    //                     from: selectedLendFilterValues.from,
    //                     to: selectedLendFilterValues.to
    //                 }
    //             }
    //         }
    //     } else if (filterConfig) {
    //         const filterValues = Array.isArray(selectedLendFilterValues[key])
    //             ? selectedLendFilterValues[key] : [selectedLendFilterValues[key]];

    //         return filterValues?.map(value => ({
    //             id: `${filterConfig.BASE_TABLE}.${filterConfig.BASE_COLUMN}`,
    //             value
    //         }))
    //     }
    //     return null;
    // }).flat().filter(Boolean);


    const filterWithFlowname = [
        {
            "id": "APPLICATION_TASKS_CONFIGS_ACTIVE.FLOW_NAME",
            "value": flowDetails && flowDetails?.flowData?.flowName
        },
        selectedLendFilterValues?.from && selectedLendFilterValues?.to && {
            id: "APPLICATION_TASKS_CONFIGS_ACTIVE.CREATED_TS",
            datatype: "DATE",
            value: {
                from: selectedLendFilterValues?.from,
                to: selectedLendFilterValues?.to
            }
        },
        selectedLendFilterValues?.APPLICATION_HIERARCHY && {
            id: "APPLICATION_TASKS_CONFIGS_ACTIVE.ASSIGNED_HIERARCHY",
            value: selectedLendFilterValues?.APPLICATION_HIERARCHY
        },
        selectedLendFilterValues?.APPLICATION_TEAM && {
            id: "APPLICATION_TASKS_CONFIGS_ACTIVE.ASSIGNED_TEAM",
            value: selectedLendFilterValues?.APPLICATION_TEAM
        }
    ].filter(Boolean);

    Object.keys(selectedLendFilterValues)?.length > 0 && cardData && (
        filterWithFlowname.push({
            "id": "APPLICATION_TASKS_CONFIGS_ACTIVE.STEP_NAME",
            "value": cardData && cardData?.stepName
        })
    )

    const handleTaskDetails = async () => {
        const tasksAPI = `${process.env.REACT_APP_BASE_URL}/api/dashboard/lend/charts/tasks`;

        const defaultdata = [{
            "id": "APPLICATION_TASKS_CONFIGS_ACTIVE.FLOW_NAME",
            "value": flowDetails?.flowData?.flowName
        }];

        let withStepName = ''
        if (cardData?.stepName) {
            withStepName = [
                {
                    "id": "APPLICATION_TASKS_CONFIGS_ACTIVE.FLOW_NAME",
                    "value": flowDetails?.flowData?.flowName
                },
                {
                    "id": "APPLICATION_TASKS_CONFIGS_ACTIVE.STEP_NAME",
                    "value": cardData?.stepName
                }
            ]
        }

        const payload = Object.keys(selectedLendFilterValues).length &&
            !cardData ? { filter: filterWithFlowname } : Object.keys(selectedLendFilterValues).length &&
                cardData ? { filter: filterWithFlowname } : flowDetails?.flowData?.flowDetails?.length > 0 &&
                    cardData?.stepName ? { filter: withStepName } : { filter: defaultdata };

        const { data } = await api(tasksAPI, 'POST', payload);
        setTaskDetails(data);
    }

    useEffect(() => {
        handleTaskDetails();
    }, [cardData, selectedLendFilterValues, flowDetails]);

    return (
        <div className='charts-comp'>
            <div className='charts-comp__chart'>
                <PieChart taskData={taskDetails} />
            </div>
            <div className='charts-comp__table'>
                <ApplicationDetails />
            </div>
        </div>
    )
}

export default ChartComponent;
